module.exports = __webpack_public_path__ + "static/media/assinatura.733d5190.svg";